<script setup lang="ts">
import { AnimatedPlaceholderProps } from "./AnimatedPlaceholder.props"

const props = withDefaults(defineProps<AnimatedPlaceholderProps>(), {
  height: "0px",
  width: "0px",
  borderRadius: "0px",
  boxShadow: "none"
})
</script>

<template>
  <div
    class="placeholder skeleton-animated_placeholder"
    :class="`shadow-${boxShadow}`"
  >
    &nbsp;
  </div>
</template>

<style scoped>
@keyframes bgAnimate {
  0% {
    background-position: 50% 0;
  }

  100% {
    background-position: -150% 0;
  }
}
.placeholder {
  height: v-bind(height);
  width: v-bind(width);
  border-radius: v-bind(borderRadius);
  background-image: linear-gradient(
    to right,
    #eeeeee 0%,
    #f0f0f0 20%,
    #f1f1f1 40%,
    #fefefe 60%,
    #f8f8f8 80%,
    #eeeeee 100%
  );
  background-size: 200% 100%;
  animation: bgAnimate 3s linear infinite;
}

@keyframes bgAnimate {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

</style>
